import { ItemActivityGroup } from "./components/ChangesByItem/buildReviewActivity";

/**
 * Decide which flyer item should be selected after activity changes:
 *   1. keep the previous selection if it is still present,
 *   2. otherwise the first group that has pending change requests,
 *   3. otherwise the first group,
 *   4. `undefined` when there are no groups.
 *
 * Pure reducer extracted from the page shell so it is unit testable.
 */
export const resolveSelectedFlyerItemId = (
  prevSelectedId: string | undefined,
  groups: ItemActivityGroup[],
): string | undefined => {
  if (groups.length === 0) return undefined;
  if (prevSelectedId && groups.some((g) => g.flyerItemId === prevSelectedId)) {
    return prevSelectedId;
  }
  const withPending = groups.find((g) => g.counts.pending > 0);
  return withPending?.flyerItemId ?? groups[0]?.flyerItemId;
};
